const AsVerificationText = {
    invalidCharactersMessage: {
        english: 'Must be less than 255 characters and may contain any character but <, >, ^, ~, (), {}, [], |, \\, /, and double quotes (")',
        spanish: 'Debe tener menos de 255 caracteres y puede contener cualquier carácter excepto <, >, ^, ~, (), {}, [], |, \\, /, y comillas dobles (")'
    },
    dateFutureError: {
        english: 'Date cannot be in the future.',
        spanish: 'La fecha no puede estar en el futuro.'
    },
    endDateIsBefore: {
        english: 'Date cannot be before the start date.',
        spanish: 'La fecha no puede ser anterior a la fecha de inicio.'
    },
    endDateIsEqual: {
        english: 'Date cannot be equal to the start date.',
        spanish: 'La fecha no puede ser la misma que la fecha de inicio.'
    }
};
export default AsVerificationText;
